import { IRespuesta } from "@infotrack/presentacion-transversales/interfacesComunes";
import IMaximosMinimos from "./entidades/IMaximosMinimos";
import IBodegaMaxMinFiltros from "./entidades/bodegaMaxMinFiltros";
import manejadorRest from "@infotrack/presentacion-utilitarios/manejadorRest";
import { negocioparametrizacion } from "Infotrack@Modelos/conexiones";

export default class ModeloMaximosMinimos {

  public ConsultarListaMaximoMinimoPorBodega(BodegaId: number) {
    return manejadorRest<IRespuesta<IMaximosMinimos>>(
        () => negocioparametrizacion.get(`MaximoMinimo/ConsultarListaMaximoMinimoPorBodega/${BodegaId}`),
        true
    );
  }

  public eliminarMaximoMinimo(maxMin: IMaximosMinimos) {
    return manejadorRest<IRespuesta<IMaximosMinimos>>(() =>
      negocioparametrizacion.delete('MaximoMinimo/EliminarMaximoMinimo', maxMin)
    );
  }

  public crearMaximoMinimo(maxMin: IMaximosMinimos) {
    return manejadorRest<IRespuesta<IMaximosMinimos>>(() =>
      negocioparametrizacion.post('MaximoMinimo/GuardarMaximoMinimo', maxMin)
    );
  }

  public editarMaximoMinimo(maxMin: IMaximosMinimos) {
    return manejadorRest<IRespuesta<IMaximosMinimos>>(() =>
      negocioparametrizacion.put('MaximoMinimo/EditarMaximoMinimo', maxMin)
    );

  }
}
